<ng-container [formGroup]="parentFormGroup">
  <mat-form-field>
    <mat-label> {{ label }} </mat-label>
    <mat-select (openedChange)="selectOpened($event)"
      [formControlName]="formCtrlName"
      multiple
      [id]="id"
      placeholder=" {{ label }} ">
      <mat-select-trigger>
        {{itemsSelectControl.value ? formatNameForItem(itemsSelectControl.value[0]) : ''}}
        @if (itemsSelectControl.value?.length > 1) {
          <span class="additional-selection">
            (+{{itemsSelectControl.value.length - 1}} {{itemsSelectControl.value?.length === 2 ? 'other' : 'others' | translate}})
          </span>
        }
      </mat-select-trigger>
      <div class="select-container">
        <mat-optgroup >
          <mat-form-field style="width:100%;">
            <input #search autocomplete="off" [placeholder]="'Search' | translate" aria-label="Search" matInput [formControl]="searchControl" id="{{ id + '-search'}}">
            @if (search.value) {
              <button [disableRipple]="true" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch($event)">
                <mat-icon >close</mat-icon>
              </button>
            }
          </mat-form-field>
        </mat-optgroup>
        @if (filteredItems?.length === 0) {
          <mat-optgroup>
            <div>{{'No results found!' | translate}}</div>
          </mat-optgroup>
        }
        @for (item of filteredItems; track item) {
          <mat-option (onSelectionChange)="itemSelectionChange($event)" [value]="item.id">
            {{ item.name }}
          </mat-option>
        }
      </div>
    </mat-select>
    @if (itemsSelectControl.value !== null) {
      <button mat-button
        matSuffix id="{{ id + '-clear'}}"
        mat-icon-button
        aria-label="Clear"
        (click)="$event.stopPropagation(); clearItems()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
</ng-container>
